const hasUrlCoupon = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const couponCode = urlParams.get("cupom");
  const shouldUseCoupon =
    couponCode && couponCode !== "null" ? couponCode : false;

  return shouldUseCoupon;
};

export default hasUrlCoupon;
